import { FormGroup, RadioGroup } from "@blueprintjs/core";
import {
  FieldLabeledProps,
  BooleanRadioProps,
  BooleanRadioFieldValue,
} from "../../types/fieldTypes";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";
import { FormFieldErrorContainer } from "../../CoreFields/FieldError/FormFieldErrorContainer";
import { useBooleanRadioField } from "./useBooleanRadioField";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { PrimaryButton } from "../../../Buttons";

/** Base BooleanRadioField Props*/
export interface BooleanRadioFieldProps extends BooleanRadioProps {
  labelProps?: FieldLabeledProps;
  showClearButton?: boolean;
}

const BooleanRadioField: React.FC<BooleanRadioFieldProps> = (props) => {
  const { localValue, setLocalValue } = useBooleanRadioField(props);

  const handleChange = (value: string) => {
    let newValue: BooleanRadioFieldValue;
    if (value === "true") {
      newValue = true;
    } else if (value === "false") {
      newValue = false;
    } else {
      newValue = null;
    }

    setLocalValue(newValue);
    props.onSubmit && props.onSubmit(newValue);
  };

  const handleClear = () => {
    setLocalValue(null);
    props.onSubmit && props.onSubmit(null);
  };

  // Convert boolean value to string for RadioGroup
  const getSelectedValue = () => {
    if (localValue === true) return "true";
    if (localValue === false) return "false";
    return undefined; // No selection for null/undefined
  };

  return (
    <div className="ucl-base-field-container ucl-base-input-radio-field-container">
      <FormGroup
        className={`${
          props.isRequired && (localValue === null || localValue === undefined)
            ? "has-required-background"
            : "base-field"
        }`}
      >
        {props.label && (
          <FieldLabel
            labelName={props.label}
            tooltipDescription={props.description}
            fieldProps={{ ...props, value: localValue }}
            isRequired={props.isRequired}
            {...props.labelProps}
          />
        )}
        <div className="ucl-radio-group-container">
          <RadioGroup
            disabled={props.disabled}
            onChange={(e) => handleChange(e.currentTarget.value)}
            selectedValue={getSelectedValue()}
            options={[
              {
                label: "Yes",
                value: "true",
              },
              {
                label: "No",
                value: "false",
              },
            ]}
            inline
          />
          {props.showClearButton &&
            localValue !== null &&
            localValue !== undefined && (
              <div className="ucl-clear-button-container">
                <PrimaryButton
                  minimal
                  text="Clear"
                  iconProps={{
                    icon: faClose,
                  }}
                  onClick={handleClear}
                  disabled={props.disabled}
                  className="ucl-clear-button"
                />
              </div>
            )}
        </div>
        {props.errorMessages && (
          <FormFieldErrorContainer errorMessages={props.errorMessages} />
        )}
      </FormGroup>
    </div>
  );
};

export default BooleanRadioField;
